import Vue from 'vue';
import Vuex from 'vuex';
import location from './modules/location';
import user from './modules/user';
import testHistory from './modules/testHistory';
import systemTest from './modules/systemTest';
import noty from './modules/noty';
import loader from './modules/loader';
import clock from './modules/clock';
import maintenanceNotification from './modules/maintenanceNotification';
import lastAlarmSignals from './modules/lastAlarmSignals';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    location,
    user,
    noty,
    loader,
    testHistory,
    systemTest,
    clock,
    maintenanceNotification,
    lastAlarmSignals
  },
  strict: process.env.NODE_ENV !== 'production'
})
